// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** RentAll - Begin **/

.WhyBlock-container-CpIvk {
	max-width: var(--max-content-width);
	margin-bottom: 84px;
	width: 100%;
}

h4.WhyBlock-common-Yn3ti {
	font-size: 24px;
	font-weight: 600;
	margin-bottom: 18px;
}

p.WhyBlock-common-Yn3ti {
	font-size: 18px;
	margin-bottom: 0;
}

.WhyBlock-whyblock-m409Y {
	background-color: #F6F6FF;
	border: 1px solid #D5D5FF;
	border-radius: 6px;
	padding: 36px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	gap: 40px;
}

.WhyBlock-gridWhy-cA7r0 {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 42px;
}

.WhyBlock-whyblockTwo-OFIGw {
	background: #FFF8EB 0% 0% no-repeat padding-box;
	border: 1px solid #FFE4B2;
}

.WhyBlock-imageObject-LxKEa {
	-o-object-fit: contain;
	   object-fit: contain;
}

.WhyBlock-imageWidthHeight-Q55hw {
	width: 100%;
	max-width: 256px;
	height: 256px;
}

@media (max-width:1200px) and (min-width:992px) {
	.WhyBlock-whyblock-m409Y {
		-ms-flex-wrap: wrap;
		    flex-wrap: wrap;
		-webkit-box-pack: center;
		    -ms-flex-pack: center;
		        justify-content: center;
	}
}

@media screen and (max-width: 991px) {
	.WhyBlock-whybnb-H19Hq {
		padding-top: 45px;
		margin-bottom: 0px;
	}

	h4.WhyBlock-common-Yn3ti {
		font-size: 23px;
		font-weight: 600;
	}

	.WhyBlock-mainhedding-bU5J5 h1 {
		font-size: 36px;
		line-height: 51px;
		margin-bottom: 13px;
	}

	.WhyBlock-gridWhy-cA7r0 {
		grid-template-columns: 100%;
	}
}

@media screen and (max-width: 767px) {
	.WhyBlock-whybnb-H19Hq {
		margin-top: 0px;
		margin-bottom: 0px;
	}

	.WhyBlock-common-Yn3ti {
		font-size: 23px;
		font-weight: 600;
	}

	.WhyBlock-whyblock-m409Y {
		padding: 20px;
		-ms-flex-wrap: wrap;
		    flex-wrap: wrap;
		-webkit-box-pack: center;
		    -ms-flex-pack: center;
		        justify-content: center;
		gap: 15px;
	}

	.WhyBlock-mainhedding-bU5J5 h1 {
		font-size: 32px;
		line-height: 51px;
		text-align: left;
		margin-bottom: 5px;
		text-align: left;
		padding-left: 15px;
		padding-right: 15px;
	}

	.WhyBlock-steps-Oh1gn {
		margin-top: 24px;
	}

	h4.WhyBlock-common-Yn3ti {
		font-size: 20px;
		margin-bottom: 10px;
	}

	p.WhyBlock-common-Yn3ti {
		font-size: 14px;
		line-height: 1.7;
		font-weight: 400;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/WhyHost/WhyBlock/WhyBlock.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;CACC,mCAAmC;CACnC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,kBAAkB;CAClB,aAAa;CACb,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,SAAS;AACV;;AAEA;CACC,aAAa;CACb,qCAAqC;CACrC,SAAS;AACV;;AAEA;CACC,+CAA+C;CAC/C,yBAAyB;AAC1B;;AAEA;CACC,sBAAmB;IAAnB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,aAAa;AACd;;AAEA;CACC;EACC,mBAAe;MAAf,eAAe;EACf,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;CACxB;AACD;;AAEA;CACC;EACC,iBAAiB;EACjB,kBAAkB;CACnB;;CAEA;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;CACpB;;CAEA;EACC,2BAA2B;CAC5B;AACD;;AAEA;CACC;EACC,eAAe;EACf,kBAAkB;CACnB;;CAEA;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,aAAa;EACb,mBAAe;MAAf,eAAe;EACf,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,SAAS;CACV;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;CACpB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,mBAAmB;CACpB;;CAEA;EACC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;CACjB;AACD","sourcesContent":["/** RentAll - Begin **/\n\n.container {\n\tmax-width: var(--max-content-width);\n\tmargin-bottom: 84px;\n\twidth: 100%;\n}\n\nh4.common {\n\tfont-size: 24px;\n\tfont-weight: 600;\n\tmargin-bottom: 18px;\n}\n\np.common {\n\tfont-size: 18px;\n\tmargin-bottom: 0;\n}\n\n.whyblock {\n\tbackground-color: #F6F6FF;\n\tborder: 1px solid #D5D5FF;\n\tborder-radius: 6px;\n\tpadding: 36px;\n\tdisplay: flex;\n\tgap: 40px;\n}\n\n.gridWhy {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(2, 1fr);\n\tgap: 42px;\n}\n\n.whyblockTwo {\n\tbackground: #FFF8EB 0% 0% no-repeat padding-box;\n\tborder: 1px solid #FFE4B2;\n}\n\n.imageObject {\n\tobject-fit: contain;\n}\n\n.imageWidthHeight {\n\twidth: 100%;\n\tmax-width: 256px;\n\theight: 256px;\n}\n\n@media (max-width:1200px) and (min-width:992px) {\n\t.whyblock {\n\t\tflex-wrap: wrap;\n\t\tjustify-content: center;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.whybnb {\n\t\tpadding-top: 45px;\n\t\tmargin-bottom: 0px;\n\t}\n\n\th4.common {\n\t\tfont-size: 23px;\n\t\tfont-weight: 600;\n\t}\n\n\t.mainhedding h1 {\n\t\tfont-size: 36px;\n\t\tline-height: 51px;\n\t\tmargin-bottom: 13px;\n\t}\n\n\t.gridWhy {\n\t\tgrid-template-columns: 100%;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.whybnb {\n\t\tmargin-top: 0px;\n\t\tmargin-bottom: 0px;\n\t}\n\n\t.common {\n\t\tfont-size: 23px;\n\t\tfont-weight: 600;\n\t}\n\n\t.whyblock {\n\t\tpadding: 20px;\n\t\tflex-wrap: wrap;\n\t\tjustify-content: center;\n\t\tgap: 15px;\n\t}\n\n\t.mainhedding h1 {\n\t\tfont-size: 32px;\n\t\tline-height: 51px;\n\t\ttext-align: left;\n\t\tmargin-bottom: 5px;\n\t\ttext-align: left;\n\t\tpadding-left: 15px;\n\t\tpadding-right: 15px;\n\t}\n\n\t.steps {\n\t\tmargin-top: 24px;\n\t}\n\n\th4.common {\n\t\tfont-size: 20px;\n\t\tmargin-bottom: 10px;\n\t}\n\n\tp.common {\n\t\tfont-size: 14px;\n\t\tline-height: 1.7;\n\t\tfont-weight: 400;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `WhyBlock-container-CpIvk`,
	"common": `WhyBlock-common-Yn3ti`,
	"whyblock": `WhyBlock-whyblock-m409Y`,
	"gridWhy": `WhyBlock-gridWhy-cA7r0`,
	"whyblockTwo": `WhyBlock-whyblockTwo-OFIGw`,
	"imageObject": `WhyBlock-imageObject-LxKEa`,
	"imageWidthHeight": `WhyBlock-imageWidthHeight-Q55hw`,
	"whybnb": `WhyBlock-whybnb-H19Hq`,
	"mainhedding": `WhyBlock-mainhedding-bU5J5`,
	"steps": `WhyBlock-steps-Oh1gn`
};
module.exports = ___CSS_LOADER_EXPORT___;
